module.exports = __webpack_public_path__ + "img/logo-full.24d91cc2.png";